import { Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useContextNavigate } from '../../hooks/navigate';
import { AppContext } from '../../components/Menu/MenuButton';
import { TasksPage } from '../TaskPage/TasksPage';
import { GamesPage } from '../GamesPage/GamesPage';

export enum ActionsContext {
    Tasks = 'tasks',
    Games = 'games',
}

export const ActionsRoutes = () => {
    const navigate = useContextNavigate<ActionsContext>();
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === `/${AppContext.Actions}`) {
            navigate(ActionsContext.Tasks, { replace: true });
        }
    }, [location.pathname, navigate]);
    
    return (
        <Routes>
            <Route path={ `/${ActionsContext.Tasks}/*` } element={<TasksPage />} />
            <Route path={ `/${ActionsContext.Games}/*` } element={<GamesPage />} />
        </Routes>
    );
};